"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMetaData = exports.generateRawReport = void 0;
const tslib_1 = require("tslib");
const utils_1 = require("../utils");
const section_generators_1 = require("./section-generators");
function generateRawReport(db, reportSchema, params) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const schemas = yield (0, utils_1.getSchemas)(db, reportSchema);
        const rawSections = [];
        const patients = [];
        if (reportSchema.type === 'group') {
            if (params === null || params === void 0 ? void 0 : params.orgGroup) {
                patients.push(...(yield db.get.users.byOrgGroup(params.orgGroup)));
            }
            else {
                patients.push(...(yield db.get.users.byOrg(reportSchema.organization)));
            }
        }
        else if (reportSchema.type === 'patient') {
            if ((params === null || params === void 0 ? void 0 : params.patient) != null) {
                patients.push(yield db.get.user.byId(params.patient));
            }
            else {
                throw new Error(`Attempted to run a patient export without specifying a patient`);
            }
        }
        else {
            throw new Error(`Received illegal reportType of ${reportSchema.type}`);
        }
        for (const sectionSchema of reportSchema.sections) {
            const rawSection = yield (0, section_generators_1.exportSection)(db, reportSchema.organization, sectionSchema, schemas, patients, reportSchema.options, params === null || params === void 0 ? void 0 : params.start, params === null || params === void 0 ? void 0 : params.end);
            if (rawSection) {
                if (!rawSection.data.length) {
                    const noDataEntry = {};
                    noDataEntry[rawSection.subtitles[0]] = 'No results';
                    for (const subtitle of rawSection.subtitles.slice(1)) {
                        noDataEntry[subtitle] = '-';
                    }
                    rawSection.data.push(noDataEntry);
                }
                rawSections.push(rawSection);
            }
        }
        const metaData = yield getMetaData(db, reportSchema, params);
        return {
            type: reportSchema.type,
            description: reportSchema.description,
            name: reportSchema.name,
            filename: (params === null || params === void 0 ? void 0 : params.filename) || `REPORT_${(0, utils_1.nowString)()}`,
            meta: metaData,
            sections: rawSections,
            options: {
                documentTitle: reportSchema.name,
            },
        };
    });
}
exports.generateRawReport = generateRawReport;
function getMetaData(db, reportSchema, params) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const created_at = new Date();
        const orgData = yield db.get.org.byId(reportSchema.organization);
        const createdBy = (params === null || params === void 0 ? void 0 : params.createdBy)
            ? yield db.get.user.byId(params.createdBy)
            : undefined;
        const patientData = reportSchema.type === 'patient' && (params === null || params === void 0 ? void 0 : params.patient)
            ? yield db.get.user.byId(params.patient)
            : undefined;
        let orgGroupData;
        if (patientData && patientData.orgGroup) {
            const orgGroup = yield db.get.orgGroup.byId(patientData.orgGroup);
            if (orgGroup)
                orgGroupData = orgGroup;
        }
        if (!orgData)
            throw new Error(`Couldn't find organization ${reportSchema.organization}`);
        return {
            created_at,
            orgData,
            createdBy,
            patientData,
            orgGroupData,
        };
    });
}
exports.getMetaData = getMetaData;
//# sourceMappingURL=index.js.map